/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Overlap_TitleInputs */

const cs_calendar_overlap_title = /** @type {(inputs: Calendar_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Překrývající se události`)
};

const en_calendar_overlap_title = /** @type {(inputs: Calendar_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlapping events`)
};

/**
* | output |
* | --- |
* | "Overlapping events" |
*
* @param {Calendar_Overlap_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_overlap_title = /** @type {((inputs?: Calendar_Overlap_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Overlap_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_overlap_title(inputs)
	return cs_calendar_overlap_title(inputs)
});